"use strict";
var Rx = require('rxjs');
var RxJSAdapter = {
    adapt: function (originStream, originStreamSubscribe) {
        if (this.isValidStream(originStream)) {
            return originStream;
        }
        return Rx.Observable.create(function (observer) {
            var dispose = originStreamSubscribe(originStream, observer);
            return function () {
                if (typeof dispose === 'function') {
                    dispose.call(null);
                }
            };
        });
    },
    remember: function (observable) {
        return observable.publishReplay(1).refCount();
    },
    makeSubject: function () {
        var stream = new Rx.Subject();
        var observer = {
            next: function (x) { stream.next(x); },
            error: function (err) { stream.error(err); },
            complete: function () { stream.complete(); },
        };
        return { stream: stream, observer: observer };
    },
    isValidStream: function (stream) {
        return (typeof stream.subscribe === 'function' &&
            typeof stream.observe !== 'function' &&
            typeof stream.subscribeOnNext !== 'function' &&
            typeof stream.onValue !== 'function');
    },
    streamSubscribe: function (stream, observer) {
        var subscription = stream.subscribe(observer);
        return function () {
            subscription.unsubscribe();
        };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RxJSAdapter;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@cycle/rxjs-adapter/lib/index.js
// module id = 29
// module chunks = 0